export const IMMERSIVEBIZCHAT_CLIENT_ID = 'c0ab8ce9-e9a0-42e7-b064-33d422df41f1';
